export enum Vendor {
  TWILIO = '0',
  TELNYX = '1',
  VONAGE = '2',
}

export function vendorIdToName(vendorId) {
  switch (vendorId) {
    case null:
      return '';
    case Vendor.TWILIO:
      return 'Twilio';
    case Vendor.TELNYX:
      return 'Telnyx';
    case Vendor.VONAGE:
      return 'Vonage';
    default:
      console.warn(`Vendor name not configured for id=${vendorId}`);
      return 'Unknown';
  }
}
